var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTake(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8167 9.13774C19.8167 13.8751 16.439 14.6109 16.439 19.026C16.439 21.3053 14.3294 21.4973 12.7236 21.4973C11.3368 21.4973 8.27462 20.9242 8.27462 19.0245C8.27462 14.6116 4.95508 13.8759 4.95508 9.13774C4.95508 4.70052 8.52524 1.10352 12.4419 1.10352C16.36 1.10352 19.8167 4.70052 19.8167 9.13774Z",
    fill: "url(#paint0_linear_17_148)",
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2021 24.9116C15.2021 25.5208 13.693 26.7509 12.3872 26.7509C11.0814 26.7509 9.57227 25.5208 9.57227 24.9116C9.57227 24.3024 11.0807 24.5437 12.3872 24.5437C13.693 24.5437 15.2021 24.3024 15.2021 24.9116Z",
    fill: "url(#paint1_linear_17_148)",
    stroke: "white",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5641 8.57314C15.5014 8.50476 15.4269 8.45051 15.345 8.41349C15.263 8.37647 15.1752 8.35742 15.0865 8.35742C14.9978 8.35742 14.9099 8.37647 14.828 8.41349C14.746 8.45051 14.6716 8.50476 14.6089 8.57314L12.3844 10.9959L10.1599 8.57314C10.0971 8.50483 10.0227 8.45065 9.94074 8.41368C9.85879 8.37671 9.77096 8.35768 9.68226 8.35768C9.59356 8.35768 9.50573 8.37671 9.42379 8.41368C9.34184 8.45065 9.26738 8.50483 9.20466 8.57314C9.14194 8.64145 9.09219 8.72254 9.05825 8.81179C9.02431 8.90104 9.00684 8.9967 9.00684 9.0933C9.00684 9.18991 9.02431 9.28557 9.05825 9.37482C9.09219 9.46407 9.14194 9.54516 9.20466 9.61347L11.7088 12.3408V20.1293C11.7088 20.3244 11.78 20.5116 11.9067 20.6496C12.0334 20.7875 12.2052 20.8651 12.3844 20.8651C12.5635 20.8651 12.7354 20.7875 12.862 20.6496C12.9887 20.5116 13.0599 20.3244 13.0599 20.1293V12.3408L15.5641 9.61347C15.6269 9.5452 15.6767 9.46412 15.7107 9.37486C15.7446 9.28561 15.7621 9.18993 15.7621 9.0933C15.7621 8.99668 15.7446 8.901 15.7107 8.81174C15.6767 8.72249 15.6269 8.64141 15.5641 8.57314Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 23C17 23.2652 16.8595 23.5196 16.6095 23.7071C16.3594 23.8946 16.0203 24 15.6667 24H10.3333C9.97971 24 9.64057 23.8946 9.39052 23.7071C9.14048 23.5196 9 23.2652 9 23V20H17V23Z",
    fill: "#09010E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32928 24.5433C8.16011 24.5426 7.99734 24.4728 7.87314 24.3477C7.74894 24.2226 7.67235 24.0514 7.65852 23.8677C7.64468 23.6841 7.6946 23.5015 7.79841 23.356C7.90222 23.2106 8.05237 23.1128 8.21917 23.0821L16.3255 21.6106C16.413 21.5942 16.5027 21.5969 16.5892 21.6185C16.6758 21.6401 16.7576 21.6802 16.8298 21.7364C16.9021 21.7927 16.9634 21.864 17.0102 21.9462C17.0569 22.0284 17.0883 22.1199 17.1023 22.2154C17.1169 22.3107 17.1142 22.4082 17.0941 22.5023C17.0741 22.5964 17.0373 22.6852 16.9857 22.7638C16.9342 22.8424 16.8689 22.9091 16.7936 22.9602C16.7183 23.0113 16.6346 23.0457 16.5471 23.0615L8.44074 24.533C8.40394 24.54 8.36664 24.5435 8.32928 24.5433ZM8.32928 21.6003C8.16011 21.5997 7.99734 21.5299 7.87314 21.4048C7.74894 21.2797 7.67235 21.1084 7.65852 20.9248C7.64468 20.7412 7.6946 20.5586 7.79841 20.4131C7.90222 20.2676 8.05237 20.1699 8.21917 20.1392L16.3255 18.6677C16.413 18.6514 16.5026 18.6541 16.5892 18.6758C16.6757 18.6974 16.7574 18.7375 16.8297 18.7937C16.9019 18.85 16.9632 18.9212 17.01 19.0034C17.0568 19.0856 17.0882 19.177 17.1023 19.2725C17.1169 19.3678 17.1142 19.4652 17.0941 19.5593C17.0741 19.6534 17.0373 19.7423 16.9857 19.8209C16.9342 19.8995 16.8689 19.9662 16.7936 20.0173C16.7183 20.0684 16.6346 20.1028 16.5471 20.1186L8.44074 21.59C8.40394 21.5971 8.36664 21.6005 8.32928 21.6003Z",
    fill: "url(#paint2_linear_17_148)",
    stroke: "white",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17_148",
    x1: 6.33266,
    y1: -0.745515,
    x2: 26.2598,
    y2: 3.89329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C54A92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E62EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17_148",
    x1: 10.0941,
    y1: 24.2922,
    x2: 11.8531,
    y2: 27.9562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C54A92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E62EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_17_148",
    x1: 8.5327,
    y1: 18.1236,
    x2: 14.1752,
    y2: 25.6839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C54A92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E62EB"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTake);
export default __webpack_public_path__ + "static/media/take.4c33c0083babeb8c1d11f80500c1e64b.svg";
export { ForwardRef as ReactComponent };